
import Msg from 'vux/src/components/msg/index.vue'


export default{
components: {
Msg
},
data () {
return {
title: '未知错误',
description1: '',
description2: '',
description3: '',
description4: '',
description5: ''
}
},
mounted () {
if (typeof this.$route.query.title === 'string') {
this.title = this.$route.query.title
}
if (typeof this.$route.query.description1 === 'string') {
this.description1 = this.$route.query.description1
}
if (typeof this.$route.query.description2 === 'string') {
this.description2 = this.$route.query.description2
}
if (typeof this.$route.query.description3 === 'string') {
this.description3 = this.$route.query.description3
}
if (typeof this.$route.query.description4 === 'string') {
this.description4 = this.$route.query.description4
}
if (typeof this.$route.query.description5 === 'string') {
this.description5 = this.$route.query.description5
}
}
}



// WEBPACK FOOTER //
// ./src/components/Error.vue